/**
 *  utils/index.js
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

var firebase = require("../firebase");

export function dateFormatter(value) {
  let formattedDate = new Date(value).toLocaleDateString();
  return formattedDate;
}

export function dateTimeFormatter(value) {
  let d = new Date(value);
  const time =
    ("00" + d.getDate()).slice(-2) +
    "/" +
    ("00" + (d.getMonth() + 1)).slice(-2) +
    "/" +
    d.getFullYear() +
    " " +
    ("00" + d.getHours()).slice(-2) +
    ":" +
    ("00" + d.getMinutes()).slice(-2) +
    ":" +
    ("00" + d.getSeconds()).slice(-2);

  return time;
}

export function currencyMask(cents) {
  if (cents === null || cents === undefined) {
    return 0;
  } else {
    var tmp = cents + "";

    if (tmp.length === 0 || tmp === 0) {
      tmp = "0,00";
    } else if (tmp.length === 1) {
      tmp = "0,0" + tmp;
    } else if (tmp.length === 2) {
      tmp = "0," + tmp;
    } else {
      tmp = tmp.replace(/([0-9]{2})$/g, ",$1");

      if (tmp.length > 6) {
        tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
      }
    }

    return "R$ " + tmp;
  }
}

export function cnpjMask(value) {
  let newValue = value.replace(/\D/g, "");

  newValue = newValue.replace(/^(\d{2})(\d)/, "$1.$2"); // Ponto entre 2º e 3º
  newValue = newValue.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3"); // Ponto entre 5º e 6º
  newValue = newValue.replace(/\.(\d{3})(\d)/, ".$1/$2"); // Barra entre 8º e 9º
  newValue = newValue.replace(/(\d{4})(\d)/, "$1-$2"); // Traço entre 12º e 13º

  return newValue;
}

export function cpfMask(value) {
  let newValue = value.replace(/\D/g, "");

  newValue = newValue.replace(/(\d{3})(\d)/, "$1.$2"); // Ponto entre 3º e 4º
  newValue = newValue.replace(/(\d{3})(\d)/, "$1.$2"); // Ponto entre 6º e 7º
  newValue = newValue.replace(/(\d{3})(\d{1,2})$/, "$1-$2"); // Traço entre 9º e 10º

  return newValue;
}

export function cepMask(value) {
  let newValue = value.replace(/\D/g, "");

  newValue = newValue.replace(/^(\d{5})(\d)/, "$1-$2");
  return newValue;
}

export function timeMask(duration) {
  let seconds = parseInt((duration / 1000) % 60),
    minutes = parseInt((duration / (1000 * 60)) % 60),
    hours = parseInt((duration / (1000 * 60 * 60)) % 24),
    days = parseInt((duration / (1000 * 60 * 60 * 24)) % 24);

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;

  if (days > 0) {
    if (days == 1) {
      return days + " dia + " + hours + ":" + minutes;
    } else {
      return days + " dias + " + hours + ":" + minutes;
    }
  }

  return minutes + ":" + seconds;
}

export function phoneMask(value) {
  let newValue = value.replace(/\D/g, "");

  newValue = newValue.replace(/\D/g, "").match(/(\d{0,2})(\d{0,5})(\d{0,4})/);
  newValue = !newValue[2]
    ? newValue[1]
    : "(" +
      newValue[1] +
      ") " +
      newValue[2] +
      (newValue[3] ? "-" + newValue[3] : "");

  return newValue;
}

export function removeMask(value) {
  let newValue = value.replace(/\D/g, "");
  return newValue;
}

export function isLogged() {
  firebase.auth.onAuthStateChanged((user) => {
    if (!user) {
      // Allow some public routes without authentication
      try {
        const hash = window.location.hash || ""; // app uses HashRouter
        const publicRoutes = ["#/policy", "#/privacy", "#/public"];
        const pathname = window.location.pathname || "";

        // if current location matches a public route, don't redirect to login
        const isPublic =
          publicRoutes.some((r) => hash.indexOf(r) === 0) ||
          ["/policy", "/privacy", "/public"].includes(pathname);

        if (!isPublic) {
          window.location.replace("/");
        }
      } catch (e) {
        window.location.replace("/");
      }
    }
  });
}

export function portugueseMessage(message) {
  if (message === "The email address is badly formatted.") {
    return (message = "Preencha os dados corretamente.");
  }
  if (
    message === "The password is invalid or the user does not have a password."
  ) {
    return (message = "Oops! Dados incorretos.");
  }
  if (
    message ===
    "There is no user record corresponding to this identifier. The user may have been deleted."
  ) {
    return (message = "Este e-mail não está vinculado a nenhuma conta.");
  }
  if (
    message ===
    "Too many unsuccessful login attempts. Please include reCaptcha verification or try again later"
  ) {
    return (message =
      "Muitas tentativas de login malsucedidas. Tente novamente mais tarde!");
  }
  if (
    message ===
    "We have blocked all requests from this device due to unusual activity. Try again later."
  ) {
    return (message =
      "Bloqueamos todos os pedidos deste dispositivo devido a atividade incomum. Tente mais tarde.");
  }
}

export function stringfy(epoch) {
  var date = new Date(epoch);
  var year = date.getFullYear().toString();
  var month = (date.getMonth() + 1).toString();
  var day = date.getDate().toString();

  if (month.length < 2) {
    month = "0" + month;
  }
  if (day.length < 2) {
    day = "0" + day;
  }

  var string = year + "-" + month + "-" + day;

  return string;
}

const defaultUrlBucketPhotos =
  "https://firebasestorage.googleapis.com/v0/b/brasil-mais-seguro.firebasestorage.app/o/users%2Fphotos%2F";

const suffixPhotos = "_profile.png?alt=media";

export function getUserPhotoUrl(userId) {
  return defaultUrlBucketPhotos + userId + suffixPhotos;
}



// WEBPACK FOOTER //
// ./src/utils/index.js